import { useCallback } from 'react';

import { DEFAULT_TOPIC } from 'pages/ParentHelper/constants';
import { useDialogContext } from 'pages/ParentHelper/providers/DialogProvider/hooks';
import { useParentHelperContext } from 'pages/ParentHelper/providers/ParentHelperProvider/hooks';
import { scrollToToday } from 'pages/ParentHelper/utils';

export const useCreateNewChat = () => {
  const { setChatId, setChatTopics } = useParentHelperContext();
  const { onClose, open } = useDialogContext();

  return useCallback(() => {
    setChatId(null);
    setChatTopics(prevData => [DEFAULT_TOPIC, ...prevData]);

    if (open) {
      onClose();
      return;
    }

    scrollToToday();
  }, [onClose, open, setChatId, setChatTopics]);
};
